import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { compactHead } from "@/data/compact/head";
import { loadCompactPage } from "@/data/compact/load";
import { permanentRedirect } from "@/lib/legacyRedirects";
import { LEGACY_LINK_TARGETS } from "@/lib/internalLinks";
import { notFoundUnlessRedirected } from "@/lib/slugGuards";

const CompactLandingPage = lazy(() => import("@/components/compact/CompactLandingPage"));

/**
 * Compact keyword-sidor under /elavtal: elavtal per bransch (företag) och per
 * situation. Statiska rutter som /elavtal/fast går alltid före den här.
 */
export const Route = createFileRoute("/elavtal/$slug")({
  beforeLoad: ({ params }) => {
    // Gamla URL:er som fortfarande länkas från artiklar, t.ex. /elavtal/jamfor-elavtal.
    const legacy = LEGACY_LINK_TARGETS[`/elavtal/${params.slug}`];
    if (legacy) permanentRedirect(legacy);
  },
  loader: async ({ params }) => {
    const page = await loadCompactPage("elavtal", params.slug);
    if (!page) return notFoundUnlessRedirected(`/elavtal/${params.slug}`);
    return { page };
  },
  head: ({ loaderData, params }) => compactHead(loaderData?.page, `/elavtal/${params.slug}`),
  component: CompactRoute,
});

function CompactRoute() {
  const { page } = Route.useLoaderData();
  return <CompactLandingPage page={page} />;
}
